
export const BlockLabel = ({ settings }) => {
  const { available_card_brands, wc_revolut_plugin_url, title } = settings
  return (
    <div className="revolut-card-label-container">
      <strong>{title}</strong>
      <div className="revolut-card-label-brands">
        {available_card_brands &&
          available_card_brands
            .filter(brand => brand !== 'maestro')
            .map(brand => (
              <img
                key={brand}
                src={`${wc_revolut_plugin_url}/assets/images/${brand}.svg`}
                style={{ marginLeft: 2 }}
                alt={brand}
              />
            ))}
      </div>
    </div>
  )
}
